import * as React from 'react';
import GenericDialog from './GenericDialog';

const MessageDialog = (props: Props) => {
	return (
		<GenericDialog buttons={props.buttons} onClose={props.onClose} width={props.width}>
			<section>
				{props.heading && <h1>{props.heading}</h1>}
				<p>{props.message}</p>
			</section>
		</GenericDialog>
	);
};

interface Props {
	heading?: string;
	message: string;
	buttons: JSX.Element | JSX.Element[];
	onClose: () => void;
	width?: number;
}

MessageDialog.defaultProps = {
	heading: null,
	width: undefined
};

export default MessageDialog;
